import { render, staticRenderFns } from "./header-search.vue?vue&type=template&id=0864c44f&scoped=true"
import script from "./header-search.vue?vue&type=script&defer=true&lang=js"
export * from "./header-search.vue?vue&type=script&defer=true&lang=js"
import style0 from "./header-search.vue?vue&type=style&index=0&id=0864c44f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0864c44f",
  null
  
)

export default component.exports